import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui/Table";
import type React from "react";
import intl from "react-intl-universal";
import { TableWrapper } from "../styled";
import type { NotificationsTableProps } from "../types";

const formatDateToUi = (value: string | null | undefined): string => {
  if (!value) return "-";
  return new Date(value).toLocaleString("pt-BR");
};

const NotificationsTable: React.FC<NotificationsTableProps> = ({ items }) => {
  return (
    <TableWrapper>
      <Table selectable={false}>
        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
          <TableRow>
            <TableHeaderColumn>
              {intl.get("masterdataAutomationNotifications.table.type")}
            </TableHeaderColumn>
            <TableHeaderColumn>
              {intl.get("masterdataAutomationNotifications.table.date")}
            </TableHeaderColumn>
            <TableHeaderColumn>
              {intl.get("masterdataAutomationNotifications.table.material")}
            </TableHeaderColumn>
            <TableHeaderColumn>
              {intl.get("masterdataAutomationNotifications.table.description")}
            </TableHeaderColumn>
          </TableRow>
        </TableHeader>

        <TableBody displayRowCheckbox={false}>
          {items.map((it) => (
            <TableRow key={it.Id}>
              <TableRowColumn>{it.ProcessingStatusDescription ?? "-"}</TableRowColumn>
              <TableRowColumn>{formatDateToUi(it.CreatedDate)}</TableRowColumn>
              <TableRowColumn>
                {it.MaterialNumber ? `${it.MaterialNumber} - ${it.MaterialDescription ?? ""}` : "-"}
              </TableRowColumn>
              <TableRowColumn className="notifications-description">
                {it.Description ?? "-"}
              </TableRowColumn>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableWrapper>
  );
};

export default NotificationsTable;
